import { createContext, useContext } from 'react';

const DataListLayoutActionsContext = createContext({ activeItem: undefined });
function useDataListLayoutActionsContext() {
    return useContext(DataListLayoutActionsContext);
}

export { DataListLayoutActionsContext as D, useDataListLayoutActionsContext as u };
